var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:{ 'error--text': _vm.props.error }},[_vm._v(" "+_vm._s(_vm.props.label)+" "),_c('div',[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.props.value || '–')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }